var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"outer-nav--return"}),_c('CookieLgpd'),_c('div',{staticClass:"l-viewport",attrs:{"id":"viewport"}},[_c('div',{staticClass:"l-wrapper"},[_c('Header'),_c('MenuLine'),_c('router-view')],1)])],1),_c('Menu'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }